import { render, staticRenderFns } from "./SideMenuStudies.vue?vue&type=template&id=768dff55&"
import script from "./SideMenuStudies.vue?vue&type=script&lang=js&"
export * from "./SideMenuStudies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('768dff55')) {
      api.createRecord('768dff55', component.options)
    } else {
      api.reload('768dff55', component.options)
    }
    module.hot.accept("./SideMenuStudies.vue?vue&type=template&id=768dff55&", function () {
      api.rerender('768dff55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/SideMenuStudies.vue"
export default component.exports